import { HttpServices } from '../../Helper';
import { config } from '../../config';

const baseURL = `${config.server_address}/CrmDfm/PartnerHub`;

const GetFilteredVendorClientTrackingsAPI = async (body) => {
  const result = await HttpServices.post(
    `${baseURL}/GetFilteredVendorClientTrackings`,
    body
  );
  return result;
};

const ExportVendorClientTrackingReportAPI = async (filter, exportType) => {
  const result = await HttpServices.post(
    `${baseURL}/ExportVendorClientTrackingReport`,
    { filter, exportType }
  );
  return result;
};

const CreateVendorClientTrackingAPI = async (body) => {
  const result = await HttpServices.get(
    `${baseURL}/CreateVendorClientTracking`,
    body
  );
  return result;
};

const GetVendorClientTrackingByIdAPI = async (trackingId) => {
  const result = await HttpServices.get(
    `${baseURL}/GetVendorClientTrackingById/${trackingId}`
  );
  return result;
};
const UpdateVendorClientTracking = async (trackingId, body) => {
  const result = await HttpServices.put(
    `${baseURL}/UpdateVendorClientTracking/${trackingId}`,
    body
  );
  return result;
};
const DeleteVendorClientTrackingAPI = async (trackingId) => {
  const result = await HttpServices.delete(
    `${baseURL}/DeleteVendorClientTracking/${trackingId}`
  );
  return result;
};

export const FilterGeneralClientTracking = async (body) => {
  const result = await HttpServices.post(
    `${baseURL}/FilterGeneralClientTracking`,
    body
  );
  return result;
};
export const BulkUpdateGeneralClientTracking = async (body) => {
  const result = await HttpServices.put(
    `${baseURL}/BulkUpdateGeneralClientTracking`,
    body
  );
  return result;
};
export const BulkUpdateGeneralClientTrackingForSingle = async (body) => {
  const result = await HttpServices.put(
    `${baseURL}/BulkUpdateGeneralClientTracking`,
    { items: [body] }
  );
  return result;
};

export const CreateGeneralInquiry = async (body) => {
  const result = await HttpServices.post(
    `${baseURL}/CreateGeneralInquiry`,
    body
  );
  return result;
};

export const ExportGeneralClientTrackingReportBulk = async (items) => {
  const result = await HttpServices.post(
    `${baseURL}/ExportGeneralClientTrackingReportBulk`,
    { items, exportType: 3 }
  );
  return result;
};

export const OfferRedemption = async (body) => {
  const result = await HttpServices.post(
    `${baseURL}/OfferRedemption`,
    body
  );
  return result;
};

export {
  GetFilteredVendorClientTrackingsAPI,
  CreateVendorClientTrackingAPI,
  GetVendorClientTrackingByIdAPI,
  UpdateVendorClientTracking,
  ExportVendorClientTrackingReportAPI,
  DeleteVendorClientTrackingAPI,
};
